var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.147 67.3226C84.3735 66.4403 85.6265 66.4403 85.853 67.3226L86.0779 68.1984C87.1406 72.3375 90.5196 75.4766 94.7256 76.2322C95.5819 76.386 95.5819 77.614 94.7256 77.7678C90.5196 78.5234 87.1406 81.6625 86.0779 85.8016L85.853 86.6774C85.6265 87.5597 84.3735 87.5597 84.147 86.6774L83.9221 85.8016C82.8594 81.6625 79.4804 78.5234 75.2744 77.7678C74.4181 77.614 74.4181 76.386 75.2744 76.2322C79.4804 75.4766 82.8594 72.3375 83.9221 68.1984L84.147 67.3226Z",
    fill: "url(#paint0_linear_45185_10369)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9075 52.6156C55.0505 51.9846 55.9495 51.9846 56.0925 52.6156L56.2428 53.2791C56.9024 56.1913 59.2325 58.4311 62.1685 58.9752C62.7504 59.0831 62.7504 59.9169 62.1685 60.0248C59.2325 60.5689 56.9024 62.8087 56.2428 65.7209L56.0925 66.3844C55.9495 67.0154 55.0505 67.0154 54.9075 66.3844L54.7572 65.7209C54.0976 62.8087 51.7675 60.5689 48.8315 60.0248C48.2496 59.9169 48.2496 59.0831 48.8315 58.9752C51.7675 58.4311 54.0976 56.1913 54.7572 53.2791L54.9075 52.6156Z",
    fill: "url(#paint1_linear_45185_10369)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45185_10369",
    x1: 85,
    y1: 63.5806,
    x2: 85,
    y2: 90.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45185_10369",
    x1: 55.5,
    y1: 50,
    x2: 55.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar7);
export default __webpack_public_path__ + "static/media/star-7.2c99a2f4f0fefa7780524fbb5f2be790.svg";
export { ForwardRef as ReactComponent };